<template>
  <div class="modal-overlay" @click.self="close">
    <div class="modal-container">
      <!-- HEADER -->
      <div class="modal-header">
        <h3>➕ Tạo khách hàng</h3>
        <button class="btn-close" @click="close">×</button>
      </div>

      <!-- BODY -->
      <div class="modal-body">
        <div class="form-grid">
          <div class="form-group">
            <label class="required">Loại khách hàng</label>
            <select v-model="form.type">
              <option value="" disabled>Chọn loại khách hàng...</option>
              <option value="Khách lẻ">Khách lẻ</option>
              <option value="Cửa hàng">Cửa hàng</option>
            </select>
          </div>
          <!-- Tên -->
          <div class="form-group">
            <label class="required">Tên khách hàng </label>
            <input v-model="form.name" placeholder="Nhập tên..." />
            <span v-if="errors.name" class="error-message">{{
              errors.name
            }}</span>
          </div>

          <!-- SĐT -->
          <div class="form-group">
            <label class="required">Số điện thoại </label>
            <input
              :class="{ 'is-invalid': errors.phone }"
              v-model="form.phone"
              placeholder="Nhập SĐT..."
              @input="validatePhone"
            />
            <span v-if="errors.phone" class="error-message">{{
              errors.phone
            }}</span>
          </div>

          <!-- Email -->
          <div class="form-group">
            <label>Email</label>
            <input v-model="form.email" placeholder="Nhập email..." />
          </div>

          <!-- Địa chỉ -->
          <div class="form-group full">
            <label>Địa chỉ</label>
            <input v-model="form.address" placeholder="Nhập địa chỉ..." />
            <span v-if="errors.address" class="error-message">{{
              errors.address
            }}</span>
          </div>

          <!-- Ghi chú -->
          <div class="form-group full">
            <label>Ghi chú</label>
            <textarea v-model="form.note" rows="3"></textarea>
          </div>
        </div>
      </div>

      <!-- FOOTER -->
      <div class="modal-footer">
        <button class="btn-cancel" @click="close">Hủy</button>

        <button class="btn-submit" @click="submitForm" :disabled="loading">
          <span v-if="loading">Đang lưu...</span>
          <span v-else>Lưu</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { adminApi } from "@/services/api";
import { useToast } from "@/composables/useToast";

const emit = defineEmits(["close", "created"]);
const toast = useToast();
const form = ref({
  type: "",
  name: "",
  phone: "",
  email: "",
  address: "",
  note: "",
});

const errors = ref({});
const loading = ref(false);

// validate
const validate = () => {
  errors.value = {};

  if (!form.value.name) {
    errors.value.name = "Vui lòng nhập tên";
  }
  if (form.value.email && !/^\S+@\S+\.\S+$/.test(form.value.email)) {
    errors.value.email = "Email không hợp lệ";
  }

  return Object.keys(errors.value).length === 0;
};

let typingTimer = null;
const validatePhone = () => {
  clearTimeout(typingTimer);
  errors.value.phone = null;
  if (!form.value.phone) {
    errors.value.phone = "Vui lòng nhập số điện thoại";
    return;
  }
  typingTimer = setTimeout(async () => {
    const vnf_regex = /((09|03|07|08|05)+([0-9]{8})\b)/g;
    if (!vnf_regex.test(form.value.phone)) {
      errors.value.phone = "Số điện thoại không đúng định dạng";
      return;
    }
    try {
      const response = await adminApi.checkExistsPhone({
        phone: form.value.phone,
      });
      if (response.data.exists) {
        errors.value.phone = "Số điện thoại đã tồn tại";
      } else {
         errors.value.phone ="";
      }
    } catch (err) {
      console.error("Lỗi validate SĐT:", err);
    }
  }, 500);
};
// submit
const submitForm = async () => {
  if (!validate()) return;

  loading.value = true;

  try {
    const res = await adminApi.createCustomer(form.value);
    emit("created", res.data);
    close();
    toast.success("Khách hàng đã được tạo thành công!");
  } catch (err) {
    console.error(err);
    toast.error("Có lỗi xảy ra khi tạo khách hàng!");
  } finally {
    loading.value = false;
  }
};

const close = () => {
  emit("close");
};
</script>

<style scoped>
input.is-invalid {
  border-color: #e53e3e;
}
</style>
